var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.up)?_c('v-icon',{staticClass:"difference-banner-increase",style:(`color: ${_vm.color}; font-size: ${_vm.size} !important`)},[_vm._v(" mdi-menu-up ")]):_c('v-icon',{staticClass:"difference-banner-increase",style:(`color: ${_vm.color}; font-size: ${_vm.size} !important`)},[_vm._v(" mdi-menu-down ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }